import HorizontalRule from "../../components/HorizontalRule/HorizontalRule";
import { VersionNote, VersionNotesHistory, Note } from "./version-notes";
import BugReportIcon from '@mui/icons-material/BugReport';
import NewReleasesIcon from '@mui/icons-material/NewReleases';


export function VersionNotesDisplayer() {



        return (
            <div className="max-h-screen p-3 overflow-y-auto">
                <h1 className="font-bold ml-2 text-[1.6em]">Release Notes</h1>
                {VersionNotesHistory.map((vn: VersionNote) => (
                    <div className="m-4 p-5 border border-zinc-300 rounded-lg shadow-md">
                        <h2 className="font-bold text-[1.4em] mb-2">{vn.version}</h2>
                        <HorizontalRule/>
                        <ul>
                            {vn.notes.map((n: Note, i: number) => (
                                <li>
                                    <h3 className="font-bold mt-3">{i+1} - {n.type === 'BUG' ? <BugReportIcon className="text-red-500"/> : <NewReleasesIcon className="text-yellow-500"/>} {n.title}</h3>
                                    <p className="ml-2 mt-1">{n.description}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        )



}